import {svgIconWrapper} from '../svg-icon-wrapper';

import OlarkRegular from './olark-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <OlarkRegular {...props} />;
}

SvgComponent.iconName = 'olarkRegular';

export const OlarkRegularIcon = svgIconWrapper(SvgComponent);
